import React from 'react';

import { Typography } from '@mui/material';
import type { GridCellParams } from '@mui/x-data-grid-premium';
import type { ReminderListRow } from 'src/components/reminders/ColumnDef';
import { formatDateForDisplay } from 'src/helpers';

export function ReminderDateCell({
  value,
}: GridCellParams<
  ReminderListRow,
  ReminderListRow['createdAt'] | ReminderListRow['dueDate'] | Date
>) {
  return <Typography>{formatDateForDisplay(value)}</Typography>;
}
